import { useCallback } from 'react';
import { useTutorial } from './TutorialProvider';

export function useTutorialTarget(id: string) {
  const { registerTarget } = useTutorial();
  return useCallback(
    (el: HTMLElement | null) => {
      registerTarget(id, el);
    },
    [id, registerTarget]
  );
}
